/* tslint:disable */
/* eslint-disable */
export enum ActionTagColour {
  Red = 'RED',
  Green = 'GREEN',
  Yellow = 'YELLOW',
  Orange = 'ORANGE',
  Teal = 'TEAL',
  Blue = 'BLUE',
  Grey = 'GREY',
}
